import { IFeatures } from "./brand.model";

export interface LoginCredentials {
  countryCode: string;
  mobileNumber: string;
  email?: string;
}

export interface VerifyOtpCredentials extends LoginCredentials {
  code: string;
  loginFrom?: 'modal' | 'form';
}

export interface RegisterCredentials extends LoginCredentials {

}

export interface Auth extends LoginCredentials {
  accessToken: string;
  userId: number,
  name: string,
  accountType: ACCOUNT_TYPE,
  accountRole: ACCOUNT_ROLE;
  email: string;
  /**
   * SAN-384 -- this user's own spoke frontend URL (e.g.
   * `https://aaf.thub.sanchidev.in`), set only when they're affiliated with
   * one and the hub/spoke flag is on. `null`/undefined means stay on the
   * current domain.
   */
  spokeUrl?: string | null;
}

export interface AuthResponse {
  accessToken: string;
}

export enum ACCOUNT_TYPE {
  STARTUP = 'startup',
  INVESTOR = 'investor',
  OTHER = 'other',
  CORPORATE = 'corporate',
  PARTNER = 'partner',
  JOB_SEEKER = 'job_seeker',
  MENTOR = 'mentor',
  SERVICE_PROVIDER = 'service_provider',
  PROGRAM_OFFICE = 'program_office',
  INDIVIDUAL = 'individual',
}

export const userTypeIdMap: Record<string, string> = {
  startup: 'startupId',
  investor: 'investorId',
  corporate: 'corporateId',
  mentor: 'mentorId',
  service_provider: 'serviceProviderId',
  partner: 'partnerId',
  program_office: 'programOfficeId',
  individual: 'individualId',
};

export function getUserIdFromProfile(profileData: any): string | null {
  if (!profileData || !profileData.accountType) return null;

  const idKey = userTypeIdMap[profileData.accountType];
  return profileData[idKey] || null;
}


export const AccountTypeTitleKey: Record<string, keyof IFeatures> = {
  [ACCOUNT_TYPE.MENTOR]: 'mentors_title',
  [ACCOUNT_TYPE.PARTNER]: "partners_title",
  [ACCOUNT_TYPE.SERVICE_PROVIDER]: "service_providers_title",
  [ACCOUNT_TYPE.PROGRAM_OFFICE]: "program_offices_title",
  [ACCOUNT_TYPE.INDIVIDUAL]: "individuals_title"
}
export enum ACCOUNT_ROLE {
  FOUNDER = 'founder',
  CO_FOUNDER = 'co_founder',
  HIRING_MANAGER = 'hiring_manager',
  BUSINESS_HEAD = 'business_head'
}


export interface IAccessTokenDetails {
  userId: number;
  accountType: string;
  accountRole: string;
  startupId: number;
  iat: number;
  exp: number;
}
